import React from "react";

const toneStyles = {
  blue: { border: "1px solid #bae6fd", background: "#f0f9ff", color: "#0c4a6e" },
  green: { border: "1px solid #a7f3d0", background: "#ecfdf5", color: "#064e3b" },
  amber: { border: "1px solid #fde68a", background: "#fffbeb", color: "#78350f" },
  red: { border: "1px solid #fecaca", background: "#fef2f2", color: "#7f1d1d" },
};

export default function StatusBanner({ children, icon: Icon, tone = "blue" }) {
  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        borderRadius: "8px",
        padding: "12px 16px",
        ...toneStyles[tone],
      }}
    >
      {Icon ? <Icon style={{ marginTop: "2px", width: "20px", height: "20px", flexShrink: 0 }} /> : null}
      <div style={{ fontSize: "14px", lineHeight: "1.6" }}>{children}</div>
    </div>
  );
}
